import ConfigForm from "../features/configuration/ConfigForm";
import ConfigRoles from "../features/configuration/ConfigRoles";
import Import from "../features/configuration/Import";
import Permission from "../features/configuration/Permission";
import Dashboard from "../features/Dashboard";
import Market from "../features/Games/Market";
import Match from "../features/Games/Match";
import Sports from "../features/Games/Sports";
import Tournaments from "../features/Games/Tournaments";
import ManageUsers from "../features/RoleManagement/ManageUsers";
import GameSettings from "../features/GlobalSettings/GameSettings";
import OpenMarket from "../features/Reports/OpenMarket";
import CancelMarket from "../features/Reports/CancelMarket";
import SettledMarket from "../features/Reports/SettledMarket";
import {
  ImportStep2,
  ImportStep3,
  ImportStep4,
} from "../features/configuration";
import Whitelabel from "../features/configuration/Whitelabel";
import TwoFactorAuth from "../features/User/TwoFactorAuth";
import BettingType from "../features/Games/BettingType";
import MarketType from "../features/Games/MarketType";
import MatchDetails from "../features/MatchDetails";
import LoginHistory from "../features/configuration/LoginHistory";

export const routeComponentMap = {
  Dashboard,
  Permission,
  Form: ConfigForm,
  Role: ConfigRoles,
  User: ManageUsers,
  EventType: Sports,
  Competition: Tournaments,
  Import: Import,
  Event: Match,
  GlobalSettings: GameSettings,
  Market: Market,
  OpenMarket: OpenMarket,
  CancelledMarket: CancelMarket,
  SettledMarket: SettledMarket,
  Whitelabel: Whitelabel,
  BettingType: BettingType,
  MarketType: MarketType,
  LoginHistory:LoginHistory,
};

export const staticComponents = {
  import: [
    {
      key: "/config/import2/:source/:id/:sportName",
      path: "/config/import2/:source/:id/:sportName",
      component: ImportStep2,
    },
    {
      key: "/config/import3/:source/:sportId/:id/:sportName/:tournamentName",
      path: "/config/import3/:source/:sportId/:id/:sportName/:tournamentName",
      component: ImportStep3,
    },
    {
      key: "/config/import4/:source/:sportId/:tournamentId/:id/:sportName/:tournamentName/:matchName",
      path: "/config/import4/:source/:sportId/:tournamentId/:id/:sportName/:tournamentName/:matchName",
      component: ImportStep4,
    },
  ],
  user_session: [
    {
      key: "two-factor-auth",
      path: "/two-factor-auth",
      component: TwoFactorAuth,
    },
    {
      key: "match-details",
      path: "/match-details/:eventId",
      component: MatchDetails,
    },
  ],
};
